import { render, staticRenderFns } from "./LeftSpecialty.vue?vue&type=template&id=cd259fa2&scoped=true&"
import script from "./LeftSpecialty.vue?vue&type=script&lang=js&"
export * from "./LeftSpecialty.vue?vue&type=script&lang=js&"
import style0 from "./LeftSpecialty.vue?vue&type=style&index=0&id=cd259fa2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd259fa2",
  null
  
)

export default component.exports